import { render, staticRenderFns } from "./PortaitEditor.vue?vue&type=template&id=22c4c0ae&scoped=true"
import script from "./PortaitEditor.vue?vue&type=script&lang=js"
export * from "./PortaitEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4c0ae",
  null
  
)

export default component.exports